import {
  GET_LIST,
  DETAIL,
  GET_LIST_BY_USER,
} from "../../api/job-readiness/job-readiness";
import moment from "moment";

const state = {
  list: [],
  detail: {},
  userJobreadiness: [],
  columns: [
    {
      label: "Employee Name",
      field: "user_name",
    },
    {
      label: "Location",
      field: "location_name",
    },
    {
      label: "Ready to Work",
      field: "employee_ready_to_work",
    },
    {
      label: "Submitted At",
      field: "created_at",
    },
    {
      label: "Action",
      field: "action",
    },
  ],
};
const mutations = {
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_DETAIL: (state, payload) => {
    state.detail = payload;
  },
  SET_LIST_BY_USER: (state, payload) => {
    state.userJobreadiness = payload;
  },
};
const actions = {
  GET_LIST: async ({ commit }, args) => {
    const resp = await GET_LIST();
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  GET_LIST_BY_USER: async ({ commit }, id) => {
    const resp = await GET_LIST_BY_USER(id);
    const data = resp.data.data;
    commit("SET_LIST_BY_USER", data);
  },
  DETAIL: async ({ commit }, args) => {
    const resp = await DETAIL(args.id);
    const data = resp.data.data;
    commit("SET_DETAIL", data);
  },
};
const getters = {
  list: (state) => state.list,
  userJobreadiness: (state) => state.userJobreadiness,
  detail: (state) => state.detail,
  columns: (state) => state.columns,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
